import { useState, useEffect } from "react";

const useFileHandler = () => {
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleDownload = async (id, field, downloadFunction, declarationId) => {
    try {
      const response = await downloadFunction(id, field, declarationId);
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      // Extract filename from Content-Disposition header
      let fileName = "file"; // Default filename
      let originFileName = "file";
      const disposition = response.headers["content-disposition"];
      if (disposition) {
        const match = disposition.match(/filename="(.+?)"/);
        if (match) {
          originFileName = match[1];
        }
      }

      // Force .jpg extension for JPEG files
      if (blob.type === "image/jpeg" && !originFileName.endsWith(".jfif")) {
        fileName = "file.jpeg";
      }

      if (blob.type === "image/jpg" && !originFileName.endsWith(".jfif")) {
        fileName = "file.jpg";
      }
      if (
        (blob.type === "image/jpeg" && originFileName.endsWith(".jfif")) ||
        (blob.type === "image/jpg" && originFileName.endsWith(".jfif")) ||
        blob.type === "image/jfif"
      ) {
        fileName = "file.jfif";
      }
      // Create a download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName.replace(/"/g, ""); // Remove any quotes
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها للتحميل. يرجى الانتظار");
      } else {
        alert(error);
      }
    }
  };

  const handlePreview = async (id, field, previewFunction, declarationId) => {
    try {
      const response = await previewFunction(id, field, declarationId);
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });

      // Create a URL for the blob
      const fileUrl = URL.createObjectURL(blob);
      return fileUrl; // Return the URL for preview
    } catch (error) {
      console.error("Preview failed:", error);
      throw error; // Re-throw the error to handle it in the component
    }
  };

  const handlePreviewClick = async (
    id,
    field,
    previewFunction,
    declarationId,
  ) => {
    try {
      const url = await handlePreview(
        id,
        field,
        previewFunction,
        declarationId,
      );
      setPreviewUrl(url); // Set the preview URL

      // Open the blob URL in a new tab
      window.open(url, "_blank");
    } catch (error) {
      // console.error("Error generating preview:", error);
      // alert("Unable to preview the file. Please try again."); // Notify the user

      if (error?.response?.status == 429) {
        alert("تعديت عدد المحاولات المسموح بها . يرجى الانتظار");
      } else {
        alert(error);
      }
    }
  };

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl); // Free up memory
      }
    };
  }, [previewUrl]);

  return {
    handleDownload,
    handlePreviewClick,
    previewUrl,
  };
};

export default useFileHandler;
